import { render, staticRenderFns } from "./CoursesSimulate.vue?vue&type=template&id=564f36fa&scoped=true"
import script from "./CoursesSimulate.vue?vue&type=script&lang=js"
export * from "./CoursesSimulate.vue?vue&type=script&lang=js"
import style0 from "./CoursesSimulate.vue?vue&type=style&index=0&id=564f36fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f36fa",
  null
  
)

export default component.exports